export default __webpack_public_path__ + "static/media/dos-01@2x.ae939093.jpg";